import React from 'react';
import classnames from 'classnames';
import { Props as IconProps, IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PlainButtonOrLink, {
  Props as BaseButtonProps,
} from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import s from './CreateButton.scss';

export interface Props extends Omit<BaseButtonProps, 'fillContainerWidth'> {
  icon?: React.ComponentType<IconProps>;
  children: React.ReactNode;
}

const CreateButton: React.FC<Props> = ({
  className,
  children,
  icon: IconComponent,
  loading,
  ...props
}) => {
  return (
    <PlainButtonOrLink
      className={classnames(
        className,
        s['root'],
        props.disabled && s['disabled'],
        loading && s['loading'],
        IconComponent && s['with-prefix-icon']
      )}
      {...props}
    >
      {IconComponent && (
        <IconComponent
          className={s['icon']}
          size={IconSize.MEDIUM}
          disableDefaultColors
        />
      )}
      <span className={s['content']}>{children}</span>
    </PlainButtonOrLink>
  );
};
CreateButton.displayName = 'CreateButton';

export default CreateButton;
